// Mirrors Stevie.Cloud.Api.vNext.Models.ColorSpace (ADR 009).
// Backend uses JsonStringEnumConverter with no naming policy, so the wire
// values are the C# member names verbatim (`sRGB`, `CMYK`).
export type ColorSpace = 'sRGB' | 'CMYK';

export const ALL_COLOR_SPACES: readonly ColorSpace[] = ['sRGB', 'CMYK'] as const;
